export class Lock {
    private _listQueue: { res: (p?: any) => void, rej: (p?: any) => void }[] = []
    private _lock = false
    Sync = async (action: () => Promise<void>) => {
        if (this._lock) {
            await new Promise((res, rej) => {
                this._listQueue.push({ res, rej })
            })
        }
        this._lock = true
        try {
            await action()
            this._listQueue.forEach(a => a.res())
        } catch (e) {
            this._listQueue.forEach(a => a.rej(e))
            throw e;
        } finally {
            this._listQueue = []
            this._lock = false

        }
    }
    Once = async <Tmodel>(action: () => Promise<Tmodel>): Promise<Tmodel> => {
        if (this._lock) {
            return await new Promise((res, rej) => {
                this._listQueue.push({ res, rej })
            })
        }
        this._lock = true
        try {
            var res = await action()
            this._listQueue.forEach(a => a.res(res))
            return res
        } catch (e) {
            this._listQueue.forEach(a => a.rej(e))
            throw e;
        } finally {
            this._listQueue = []
            this._lock = false

        }
    }
}